{
  "home": "Hjem",
  "search": "Søk",
  "forestowner": "Skogeiere",
  "forestownerInformation": "Skogeieropplysninger",
  "bulkSms": "Masseutsendelse av SMS",
  "shortcuts": "Snarveier",
  "skogmodul": "Skogmodul",
  "timberbuyer": "Tømmerkjøper",
  "backToForestOwner": "Tilbake til skogeier",
  "backToSearch": "Tilbake til søk",
  "backTo": "Tilbake til {{name}}",
  "register": "Registrer skogeier",
  "edit": "Endre skogeieropplysninger"
}
